var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { display: "flex", "flex-direction": "column", gap: "16px" },
    },
    [
      _vm.data.ascending && _vm.data.id === "startEvent"
        ? _c(
            "div",
            {
              staticClass: "sfcArrowLine okLine",
              class: { showArrow: _vm.showArrow, vertical: _vm.vertical },
              style: { color: _vm.data.color },
            },
            [_c("span", { staticClass: "line-text" }, [_vm._v("OK")])]
          )
        : _vm._e(),
      _vm.data.ascending && _vm.data.id !== "startEvent"
        ? _c(
            "div",
            {
              staticClass: "sfcArrowLine okLine",
              class: { showArrow: _vm.showArrow, vertical: _vm.vertical },
              style: { color: _vm.data.color },
            },
            [
              _c("span", { staticClass: "line-text" }, [
                _vm._v(_vm._s(_vm.data.qtyTotal)),
              ]),
            ]
          )
        : _vm._e(),
      _vm.data.descending
        ? _c("div", { staticClass: "arrowWrapper" }, [_vm._m(0)])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sfcArrowLine showArrow reverse ngLine" }, [
      _c("span", { staticClass: "line-text" }, [_vm._v("NG")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }